import React, { useState, useEffect } from 'react';
import { useHistory, useLocation  } from 'react-router-dom';
import {
  Navbar,
  Nav,
  Button,
  NavItem,
  NavLink,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Popover,
  PopoverBody,
  ListGroup,
  ListGroupItem
} from 'reactstrap';
import {
  MdAccessibility,
  MdClearAll,
  MdExitToApp,
  MdNotificationsActive,
  MdNotificationsNone
} from 'react-icons/md';
import Avatar from 'components/Avatar';
import { UserCard } from 'components/Card';
import Notifications from 'components/Notifications';
import withBadge from 'hocs/withBadge';
import bn from 'utils/bemnames';
import { Cookies } from 'react-cookie';
import DataAdapter from '../../vortex/adapter/DataAdapter';
import Project from '../../vortex/model/Projects/Project';
import TaskDetail from '../../vortex/model/TaskDetails/TaskDetail';
import Task from '../../vortex/model/Tasks/Task';
import Person from '../../vortex/model/Persons/Person';
import Invoice from '../../vortex/model/Invoices/Invoice';
import ReceiveAndPayment from '../../vortex/model/Accounting/ReceiveAndPayment';
import Accounting from '../../vortex/model/Accounting/Accounting';



const bem = bn.create('header');
const cookie = new Cookies();

const MdNotificationsActiveWithBadge = withBadge({
  size: 'sm',
  color: 'primary',
  style: {
    top: -10,
    right: -10,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  children: <small></small>
})(MdNotificationsActive);

const getSource = (_id) => {
  let _src = require('assets/img/users/avetar.jpg');
  try {
    _src = require('assets/img/users/' + _id + '.jpg');
  } catch (err) {}
  return _src;
};

const Header = () => {
  const [canChangeRoles, setCanChangeRoles] = useState(false);
  const [persons, setPersons] = useState([{}]);
  const [roles, setRoles] = useState([{}]);
  const [notificationsData, setNotificationsData] = useState({});
  const [isOpenNotificationPopover, setIsOpenNotificationPopover] = useState(false);
  const [isNotificationConfirmed, setIsNotificationConfirmed] = useState(false);
  const [isOpenUserCardPopover, setIsOpenUserCardPopover] = useState(false);
  const history = useHistory();

  useEffect(() => {
      document.title  = usePageTitle();

    new DataAdapter("SELECT * FROM rb_person WHERE person_type=8 AND user_expire_date > now();")
      .getRecords()
      .then(data => setPersons(data));

    new DataAdapter(`SELECT rb_type_no as id, rb_type_desc as role FROM rb_types where rb_type = 'person_role' and find_in_set(rb_type_no,(select person_role from rb_person where person_id=${cookie.get('v-person-id')}))>0 ORDER BY rb_type_no;`)
      .getRecords()
      .then(data => setRoles(data));

    new DataAdapter(`SELECT pt.task,ptd.ptd_id, ty.rb_type_desc AS task_type, ty.rb_type_no AS task_type_id, ptd.note, ptd.task_description, ptd.start_date, prr.name AS sender, ptd.sender_id, pr.name AS receiver, ptd.receiver_id, ptd.attachments, prj.prj_id, prj.prj_title, prj.prj_address, prj.prj_posted_date FROM rb_project_task_details ptd LEFT JOIN rb_project_tasks pt ON pt.pt_id=ptd.pt_id LEFT JOIN rb_projects prj ON prj.prj_id =ptd.prj_id LEFT JOIN rb_types ty ON (ty.rb_type = 'task_type' AND ty.rb_type_no = ptd.task_type ) LEFT JOIN rb_person pr ON pr.person_id = ptd.receiver_id LEFT JOIN rb_person prr ON prr.person_id = ptd.sender_id WHERE ty.rb_type_type_id=20 AND ptd.receiver_id=${cookie.get('v-person-id')} AND ptd.task_status=8 ORDER BY ptd.ptd_id DESC;`)
      .getRecords()
      .then(data => setNotificationsData(data));
  }, []);

  
  const usePageTitle = () => {
    
    const path = window.location.hash.split('/');
    return path[1] ? decodeURIComponent(path[1]) : 'AugmentSite 8CO';
  };
  
  const toggleNotificationPopover = () => {
    setIsOpenNotificationPopover(!isOpenNotificationPopover);
    if (!isNotificationConfirmed) {
      setIsNotificationConfirmed(true);
    }
  };

  const toggleUserCardPopover = () => {
    setIsOpenUserCardPopover(!isOpenUserCardPopover);
  };

  const handleSidebarControlButton = (event) => {
    event.preventDefault();
    event.stopPropagation();
    document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
  };

  const onSignoutHandler = (event) => {
    event.preventDefault();
    [
      'v-person-id','v-email','v-tel','v-name','v-lastname','v-person-title','v-person-type','v-person-role','v-person-role-name','v-person-desc','v-email-organization','v-tel-organization','v-name-signature','v-lastname-signature','v-title-signature','v-tel-signature','v-email-signature','v-link-signature','v-ext-signature','v-cell-signature','v-person-token'
    ].forEach(c => cookie.remove(c));
    history.push('/login');
    window.location.reload();
  };

  const onRoleChangeHandler = (e) => {
    cookie.remove('v-person-role');
    cookie.set('v-person-role', e.target.value);
    window.location.reload();
  };

  const onPersonChangeHandler = (e) => {
    e.persist();
    cookie.remove('v-person-id');
    cookie.remove('v-name');
    cookie.remove('v-lastname');
    cookie.set('v-person-id', e.target.value);
    cookie.set('v-name', e.target.selectedOptions[0].attributes[0].nodeValue);
    cookie.set('v-lastname', e.target.selectedOptions[0].attributes[1].nodeValue);
    window.location.reload();
  };

  return (
    <Navbar light expand className={bem.b('bg-white')}>
      <Nav navbar className="mr-2">
        <Button outline onClick={handleSidebarControlButton}>
          <MdClearAll size={25} />
        </Button>
      </Nav>
      <Nav navbar className="mr-2"></Nav>
      <Nav navbar className="mr-2">
		{/* Module : new_items_button */}
			{cookie.get('v-person-role')*1 == 1 || cookie.get('v-person-role')*1 == 10 || cookie.get('v-person-role')*1 == 11 || cookie.get('v-person-role')*1 == 14?
			<>
              <UncontrolledButtonDropdown className="m-1">
                <DropdownToggle caret >
                  New
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={(e)=>{	var _person	=new Person();_person.openFormPerson(-1); }} >Person</DropdownItem>
                  <DropdownItem disabled onClick={(e)=>{}} >Project</DropdownItem>
                  <DropdownItem onClick={(e)=>{	var _task	=new Task();_task.openQuickTaskForm(-1); }} >Task</DropdownItem>
                  <DropdownItem disabled >Note</DropdownItem>
                  <DropdownItem onClick={(e)=>{	var _receiveAndPayment	=new ReceiveAndPayment(); _receiveAndPayment.openReceiveAndPayment(); }} >Receive/Payment</DropdownItem>
                  <DropdownItem disabled >Email/SMS</DropdownItem>
                  <DropdownItem disabled >Alarm</DropdownItem>
                  <DropdownItem disabled >Picture</DropdownItem>
                  <DropdownItem onClick={(e)=>{	var _project	=new Project();_project.provideEstimate(); }} >Estimate</DropdownItem>
                  <DropdownItem onClick={(e)=>{	var _project	=new Project();_project.provideQuote(); }} >Quote</DropdownItem>
                  <DropdownItem onClick={(e)=>{	var _project	=new Project();_project.provideInvoice(); }} >Invoice</DropdownItem>
                  <DropdownItem onClick={(e)=>{	var _invoice	=new Invoice();_invoice.openLog(1,-1); }} >Project Log</DropdownItem>
                  <DropdownItem onClick={(e)=>{	var _accounting	=new Accounting();_accounting.openPurchase(); }} >Purchase/Sale</DropdownItem>
                  <DropdownItem onClick={(e)=>{	
	  						var taskDetail =new TaskDetail();
							taskDetail.openClockInOut();

				  }} >Clock In/Out</DropdownItem>
                  <DropdownItem onClick={(e)=>{	var _project	=new Project();_project.provideReport(); }} >Project Report</DropdownItem>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
              <UncontrolledButtonDropdown className="m-1">
                <DropdownToggle caret >
                  View
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={(e)=>{	var _person	=new Person(); _person.openViewPersons(); }} >Person</DropdownItem>
                  <DropdownItem onClick={(e)=>{	var _project	=new Project(); _project.viewProjectPlan(); }} >Project Plan</DropdownItem>
                  <DropdownItem onClick={(e)=>{	var _taskDetail	=new TaskDetail(); _taskDetail.openProjectLogs({}, 93); }} >Project Log</DropdownItem>
                  <DropdownItem onClick={(e)=>{	var _taskDetail	=new TaskDetail(); _taskDetail.openProjectLogs({}, 122); }} >Project Clock</DropdownItem>
                  <DropdownItem onClick={(e)=>{	var _taskDetail	=new TaskDetail(); _taskDetail.openProjectLogs({}, 83); }} >Purchase</DropdownItem>
                  <DropdownItem onClick={(e)=>{	var _taskDetail	=new TaskDetail(); _taskDetail.openProjectLogs({}, 37); }} >Notes</DropdownItem>
                  <DropdownItem onClick={(e)=>{	var _taskDetail	=new TaskDetail(); _taskDetail.viewDailyTimeSheet(); }} >Timesheet</DropdownItem>
                  <DropdownItem onClick={(e)=>{	var _taskDetail	=new TaskDetail(); _taskDetail.viewProjectLogs(-1); }} >Daily Report</DropdownItem>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
			  </>
			:''}
			  
        </Nav>
      <Nav navbar className="mr-2">
        {/* Add your custom buttons here */}
      </Nav>
      <Nav navbar className={bem.e('nav-right')}>
        <NavItem className="d-inline-flex">
          <NavLink id="Popover1" className="position-relative">
            {isNotificationConfirmed ? (
              <MdNotificationsNone
                size={25}
                className="text-secondary can-click"
                onClick={toggleNotificationPopover}
              />
            ) : (
              <MdNotificationsActiveWithBadge
                size={25}
                className="text-secondary can-click animated swing infinite"
                onClick={toggleNotificationPopover}
              />
            )}
          </NavLink>
          <Popover
            placement="bottom"
            isOpen={isOpenNotificationPopover}
            toggle={toggleNotificationPopover}
            target="Popover1"
          >
            <PopoverBody>
              <Notifications notificationsData={notificationsData} onClick={() => setIsOpenNotificationPopover(false)} />
            </PopoverBody>
          </Popover>
        </NavItem>

        <NavItem>
          <NavLink id="Popover2">
            <Avatar className="can-click" src={getSource(cookie.get('v-person-id'))} title={cookie.get('v-name')} />
          </NavLink>
          <Popover
            placement="bottom-end"
            isOpen={isOpenUserCardPopover}
            toggle={toggleUserCardPopover}
            target="Popover2"
            className="p-0 border-0"
            style={{ minWidth: 250 }}
          >
            <PopoverBody className="p-0 border-light">
              <UserCard
                title={cookie.get('v-name') + ' ' + cookie.get('v-lastname')}
                subtitle={cookie.get('v-email')}
                text={`
                  ${cookie.get('v-name-signature')} ${cookie.get('v-lastname-signature')}<br/>
                  ${cookie.get('v-title-signature')}<br/>
                  ${cookie.get('v-department-desc')}<br/>
                  TELL  | ${cookie.get('v-tel-signature')}<br/>
                  ${cookie.get('v-email-signature')}`}
                className="border-light"
              >
                <ListGroup flush>
                  {cookie.get('v-person-id') * 1 === 0 || cookie.get('v-person-id') * 1 === 66 || canChangeRoles ? (
                    <>
                      <ListGroupItem tag="button" action className="border-light">
                        <label>Person : </label><br />
                        <select style={{ width: '100%' }} defaultValue={cookie.get('v-person-id')} onChange={onPersonChangeHandler}>
                          <option value="">-</option>
                          {persons && persons.map((p, i) => (
                            <option key={i} data-name={p.name} data-lastname={p.lastname} value={p.person_id}>
                              {p.name + ' ' + p.lastname}
                            </option>
                          ))}
                        </select>
                      </ListGroupItem>
                      <ListGroupItem tag="button" action className="border-light">
                        <label>Role : </label><br />
                        <select style={{ width: '100%' }} defaultValue={cookie.get('v-person-role')} onChange={onRoleChangeHandler}>
                          <option value="">-</option>
                          {roles && roles.map((r, i) => (
                            <option key={i} value={r.id}>{r.role}</option>
                          ))}
                        </select>
                      </ListGroupItem>
                    </>
                  ):
                  <>
                    <ListGroupItem onClick={(e)=>{var _pass = prompt( global.config.version);if(_pass=='8co@8co')setCanChangeRoles(true);}} tag="button" action className="border-light">
                      <MdAccessibility /> Version
                    </ListGroupItem>
                  </>
                  }
                  <ListGroupItem onClick={onSignoutHandler} tag="button" action className="border-light">
                    <MdExitToApp /> Signout
                  </ListGroupItem>
                </ListGroup>
              </UserCard>
            </PopoverBody>
          </Popover>
        </NavItem>
      </Nav>
    </Navbar>
  );
};

export default Header;
